const selectMovieGenres = (state) => state.movies.genres;

export default selectMovieGenres;
